import React from "react";
import {
    Modal,
    Box,
    Typography,
    Link,
    Paper,
    IconButton,
    Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: 800,
    maxHeight: "80vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 3,
    overflow: "auto",
    p: 3,
};

const SnippetModal = ({ open, handleClose, data }) => {
    if (!data || data.length === 0) return null;

    const formatSnippet = (text) => {
        if (!text) return "";
        return text
            .replace(/\{ts:(\d+)\}/g, "⏱ ($1s)") // show timestamps nicely
            .replace(/\n{2,}/g, "\n")
            .trim();
    };

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="snippet-modal">
            <Box sx={style}>
                {/* Header */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography id="snippet-modal" variant="h5" fontWeight="bold">
                        Snippet Insights
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {/* Content */}
                {data.map((item, index) => (
                    <Paper
                        key={index}
                        variant="outlined"
                        sx={{
                            p: 2,
                            mb: 2,
                            borderRadius: 2,
                            backgroundColor: "#fafafa",
                        }}
                    >
                        <Typography variant="h6" color="primary" gutterBottom>
                            <Link
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{ fontWeight: 600 }}
                            >
                                {item.title}
                            </Link>
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                whiteSpace: "pre-wrap",
                                lineHeight: 1.6,
                            }}
                        >
                            <ReactMarkdown>{formatSnippet(item.snippet)}</ReactMarkdown>
                        </Typography>
                    </Paper>
                ))}
            </Box>
        </Modal>
    );
};

export default SnippetModal;
